var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcOpen = function SvgIcOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 51 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C375EE",
    stroke: "#C375EE",
    strokeWidth: 2,
    d: "M26.46 1.219a3 3 0 0 0-2.249 0L2.876 9.844a3 3 0 0 0-1.855 3.132L4.7 44.26a3 3 0 0 0 1.903 2.45l17.655 6.79a3 3 0 0 0 2.153 0l17.655-6.79a3 3 0 0 0 1.903-2.45l3.68-31.284a3 3 0 0 0-1.855-3.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C375EE",
    d: "M25.5 2.007V29.5l19.363 15.112a2 2 0 0 1-1.155 1.164l-17.654 6.79a2 2 0 0 1-.554.127V32.5L2.263 11.634c.217-.38.56-.69.988-.863l21.335-8.625a2 2 0 0 1 .914-.14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8537B1",
    d: "M26.25 5.163a2 2 0 0 0-1.5 0l-18.7 7.56a2 2 0 0 0-1.236 2.088l3.232 27.472a2 2 0 0 0 1.268 1.633l15.468 5.949a2 2 0 0 0 1.436 0l15.468-5.95a2 2 0 0 0 1.268-1.632l3.232-27.472a2 2 0 0 0-1.236-2.088z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#ic-open_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.5a2 2 0 0 0 2 2h17a2 2 0 1 0 0-4h-17a2 2 0 0 0-2 2M21.5 29.5a2 2 0 1 1 0-4h12a2 2 0 1 1 0 4zM16.5 36.5a2 2 0 1 1 0-4h17a2 2 0 1 1 0 4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic-open_svg__a",
    width: 21,
    height: 19,
    x: 14.5,
    y: 18.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.117647 0 0 0 0 0.027451 0 0 0 0 0.380392 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_871_3527"
  })))));
};
export default SvgIcOpen;